export function RefreshIcon() {
    return (
        <svg
            focusable='false'
            aria-hidden='true'
            width='20'
            height='20'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M20 4V9H15' stroke='currentColor' strokeWidth='1' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M4 20V15H9' stroke='currentColor' strokeWidth='1' strokeLinecap='round' strokeLinejoin='round' />
            <path
                d='M19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C8.97712 19.5 6.37088 17.7122 5.1903 15.1361M4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C15.0229 4.5 17.6291 6.28781 18.8097 8.86395'
                stroke='currentColor'
                strokeWidth='1'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
}
